var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthSavingsAccountColoured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22557_14641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.559 30.9068C19.9738 31.271 20.402 31.6468 20.8424 32.0363C20.8454 32.039 20.8485 32.0417 20.8515 32.0443L22.3168 33.31C22.5131 33.4796 22.7567 33.5643 23.0003 33.5643C23.244 33.5643 23.4877 33.4795 23.684 33.31L25.1489 32.0443C25.152 32.0417 25.155 32.039 25.158 32.0364C28.0585 29.4713 30.2332 27.5075 31.8065 25.5922C33.6441 23.3553 34.5001 21.3327 34.5001 19.2271C34.5001 15.4176 31.516 12.4336 27.7067 12.4336C25.9946 12.4336 24.3028 13.0783 23.0003 14.1958C21.6975 13.0782 20.0058 12.4336 18.2936 12.4336C14.4841 12.4335 11.5 15.4176 11.5 19.227C11.5 23.8319 14.7061 26.6464 19.559 30.9068ZM18.8173 20.9077H21.6057V18.1191H24.3942V20.9077H27.1827V23.6962H24.3942V26.4846H21.6057V23.6962H18.8173V20.9077Z",
    fill: "#7AB6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22557_14641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSavingsAccountColoured);
export default __webpack_public_path__ + "static/media/health_savings_account_coloured.7e124a2333c20149f44012065a6f86f9.svg";
export { ForwardRef as ReactComponent };